import { useStylesHook } from "../hooks/useStylesHook";
import { TMS_THEME } from "../theming/theming";
export const useModalTitleClasses = (type, isSpan) => {
    let icon = {};
    if (type === "success") {
        icon = {
            fontSize: 28.5,
            color: "#fff",
            backgroundColor: TMS_THEME.palette.success.base.color,
            borderRadius: "50%",
            border: "8px solid",
            padding: 9,
        };
    }
    else {
        icon = {
            marginBottom: 6,
            fontSize: "xxx-large",
        };
    }
    if (type === "warning" || type === "warningWithoutCancel") {
        icon = {
            ...icon,
            color: TMS_THEME.palette.warning.base.color,
        };
    }
    if (type === "info") {
        icon = {
            ...icon,
            color: TMS_THEME.palette.primary.base.color,
        };
    }
    if (type === "error") {
        icon = {
            ...icon,
            color: TMS_THEME.palette.error.base.color,
        };
    }
    return useStylesHook({
        title: {
            fontWeight: "bold !important",
            marginBottom: "12px !important",
            margin: "0px !important",
            lineHeight: "1.428571429 !important",
            fontSize: "18px !important",
            display: "block",
            fontFamily: isSpan ? "var(--font-family-header)" : {},
        },
        icon,
        wrapper: !!type
            ? {
                textAlign: "center",
            }
            : {},
    });
};
